import { render, staticRenderFns } from "./PlanCard.vue?vue&type=template&id=39db5926&scoped=true"
import script from "./PlanCard.vue?vue&type=script&lang=js"
export * from "./PlanCard.vue?vue&type=script&lang=js"
import style0 from "./PlanCard.vue?vue&type=style&index=0&id=39db5926&prod&lang=less&scoped=true"
import style1 from "./PlanCard.vue?vue&type=style&index=1&id=39db5926&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db5926",
  null
  
)

export default component.exports